import ContentLoading from "component/LoadingComponent/ContentLoading";
import TypeAHeadSearchComponent from "component/TypeAHeadComponent";
import InnerHeader from "component/shared/innerheader/InnerHeader";
import { END_POINTS } from "constants/APIConstant";
import CustomizedSearchPage from "pages/customizedSearchPageComponent";
import {
  // useCallback,
  useEffect,
  useState,
  useRef,
} from "react";
import { Col, Row } from "react-bootstrap";
import { FormattedMessage, useIntl } from "react-intl";
import useSWR from "swr";
import "./advance-search-page.scss";
import { SEARCH_BASE_URL } from "configs/AppConfig";
import { useLocation } from "react-router-dom";
import ChevronIcon from "svg-icons/chevron-icon";
import ReactGA from "react-ga4";

const AdvancedSearchPage = () => {
  const intl = useIntl();

  ReactGA.initialize(END_POINTS.TRACKING_ID);

  useEffect(() => {
    // Send pageview with a custom path
    ReactGA.send({
      hitType: "pageview",
      page: "/advanced-search",
      title: "Advanced Search Page",
    });
  }, []);

  const { state } = useLocation();
  const currentSearch = state?.currentSearch; // Read values passed on state

  const [searchTerm, setSearchTerm] = useState(currentSearch || "");
  const searchInputRef = useRef(null);
  const defaultQueryState = {
    searchTerm: currentSearch || "",
  };
  const [queryFilters, setQueryFilters] = useState(defaultQueryState);

  const callSearchApi = () => {
    if (
      queryFilters.searchTerm === "" ||
      queryFilters.searchTerm === null ||
      queryFilters.searchTerm.length < 3
    ) {
      return false;
    }
    return true;
  };

  // Update searchTerm and queryFilters when currentSearch changes from Nav
  useEffect(() => {
    if (
      currentSearch !== "" &&
      currentSearch !== null &&
      currentSearch !== undefined
    ) {
      const trimmedSearch = currentSearch.trim();
      setSearchTerm(trimmedSearch);
      setQueryFilters({ searchTerm: trimmedSearch });
      searchInputRef.current = trimmedSearch;
    }
  }, [currentSearch]);

  const newsSearchingItems = useSWR(
    callSearchApi()
      ? {
          url: `${SEARCH_BASE_URL}/${END_POINTS.NEWS_ADVANCED_SEARCH}`,
          params: queryFilters,
        }
      : null
  );

  const publicationsSearchingItems = useSWR(
    callSearchApi()
      ? {
          url: `${SEARCH_BASE_URL}/${END_POINTS.PUBLICATIONS_ADVANCED_SEARCH}`,
          params: queryFilters,
        }
      : null
  );

  const indicatorsSearchingItems = useSWR(
    callSearchApi()
      ? {
          url: `${SEARCH_BASE_URL}/${END_POINTS.INDICATORS_ADVANCED_SEARCH}`,
          params: queryFilters,
        }
      : null
  );
  const onSearchTermChange = (newSearchTerm) => {
    const trimmedTerm = newSearchTerm?.trim() || "";
    setSearchTerm(trimmedTerm);
    if (trimmedTerm.length >= 3) {
      setQueryFilters({ searchTerm: trimmedTerm });
    }
  };
  const getObjectWithKey = ({ objKey }) => {
    switch (objKey) {
      case "news":
        return newsSearchingItems.error ||
          newsSearchingItems.isLoading ||
          newsSearchingItems.data === undefined
          ? []
          : newsSearchingItems.data.data;
      case "publications":
        return publicationsSearchingItems.error ||
          publicationsSearchingItems.isLoading ||
          publicationsSearchingItems.data === undefined
          ? []
          : [
              ...publicationsSearchingItems.data.data?.item1,
              ...publicationsSearchingItems.data.data?.item2,
            ];
      case "indicators":
        return indicatorsSearchingItems.error ||
          indicatorsSearchingItems.isLoading ||
          indicatorsSearchingItems.data === undefined
          ? []
          : indicatorsSearchingItems.data.data;
    }
  };
  return (
    <div className="advanced-search">
      <InnerHeader
        breadcrumb={[
          {
            title: <FormattedMessage id="search-according-subject" />,
            clickClass: true,
          },
        ]}
        title={intl.formatMessage({ id: "search-according-subject-result" })}
      />
      <div className="container">
        <div className="textFieldSearchComponent">
          <Row
            style={{
              width: "100%",
              justifyContent: "start",
              marginInline: "10px",
              alignItems: "center",
            }}
          >
            <Col md={12} lg={3} xl={2} xxl={2}>
              <div className="title">
                {intl.formatMessage({ id: "search-term" })}
              </div>
            </Col>
            <Col xs={8} md={9} lg={7} xl={8} xxl={8}>
              <div>
                <TypeAHeadSearchComponent
                  onSearchTermChange={(value) => {
                    const trimmedValue = value?.trim() || "";
                    setSearchTerm(trimmedValue);
                    searchInputRef.current = trimmedValue;
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      const termToSearch =
                        searchInputRef.current ||
                        searchTerm ||
                        queryFilters.searchTerm ||
                        "";
                      if (termToSearch.trim().length >= 3) {
                        onSearchTermChange(termToSearch);
                      }
                    }
                  }}
                  currentValue={searchTerm}
                  disableDropDown={true}
                  autoFocus={true}
                  fetchingData={[
                    { id: 1, title: queryFilters.searchTerm || searchTerm },
                  ]}
                />
              </div>
            </Col>
            <Col xs={4} md={3} lg={2} xl={2} xxl={2}>
              <div>
                <button
                  className="main-btn"
                  style={{ height: "100% !important" }}
                  onClick={() => {
                    const termToSearch =
                      searchInputRef.current ||
                      searchTerm ||
                      queryFilters.searchTerm ||
                      "";
                    if (termToSearch.trim().length >= 3) {
                      onSearchTermChange(termToSearch);
                    }
                  }}
                >
                  <span>
                    <FormattedMessage id="search" />
                  </span>
                  <ChevronIcon width={12} height={12} color="#FFFFFF" />
                </button>
              </div>
            </Col>
          </Row>
        </div>
      </div>
      <ContentLoading
        isLoading={newsSearchingItems.isLoading}
        className="advanced-search"
      >
        <CustomizedSearchPage
          indicators={getObjectWithKey({ objKey: "indicators" })}
          mainSubjectId={null}
          disableIndicatorsLink={true}
          publications={getObjectWithKey({ objKey: "publications" })}
          news={getObjectWithKey({ objKey: "news" })}
          renderNewsTitleOnly={false}
        />
      </ContentLoading>
    </div>
  );
};
export default AdvancedSearchPage;
